export default [
  {
    name: '上海城市公司',
    address: {
      lat: '31.257812',
      lng: '121.421741',
    },
  },
  {
    name: '许昌（花都）',
    address: {
      lat: '31.305213',
      lng: '121.312359',
    },
  },
  {
    name: '上海市精神卫生中心老年科',
    address: {
      lat: '31.187251',
      lng: '121.448074',
    },
  },
  {
    name: '爱照护（长征）',
    address: {
      lat: '31.236133',
      lng: '121.376419',
    },
  },
  {
    name: '上海金福居敬老院',
    address: {
      lat: '30.898877',
      lng: '121.323548',
    },
  },
  {
    name: '爱志旺日间照料会所',
    address: {
      lat: '31.188503',
      lng: '121.45675',
    },
  },
  {
    name: '香港莫朗福克斯公馆',
    address: {
      lat: '31.117448',
      lng: '121.622799',
    },
  },
  {
    name: '梅陇颐乐养老院',
    address: {
      lat: '31.085863',
      lng: '121.430852',
    },
  },
  {
    name: '上海尽美长者服务中心',
    address: {
      lat: '30.992221',
      lng: '121.470792',
    },
  },
  {
    name: '荣上记忆家园福利院',
    address: {
      lat: '31.325283',
      lng: '121.513295',
    },
  },
  {
    name: '爱照护（万里）',
    address: {
      lat: '31.276091',
      lng: '121.399718',
    },
  },
  {
    name: '爱照护总部',
    address: {
      lat: '',
      lng: '',
    },
  },
  {
    name: '上海市普陀区白丽敬老院',
    address: {
      lat: '31.283199',
      lng: '121.350869',
    },
  },
  {
    name: '上海普陀区爱晚亭敬老院',
    address: {
      lat: '31.221685',
      lng: '121.399343',
    },
  },

  {
    name: '上海普陀区桃浦镇社会福利院',
    address: {
      lat: '31.260742',
      lng: '121.366945',
    },
  },

  {
    name: '爱照护（真如意）',
    address: {
      lat: '31.251975',
      lng: '121.383631',
    },
  },
  {
    name: '上海普陀区曹安敬老院',
    address: {
      lat: '31.235848',
      lng: '121.39858',
    },
  },
  {
    name: '上海曹家巷长者照护之家',
    address: {
      lat: '31.227916',
      lng: '121.411392',
    },
  },
  {
    name: '上海曹杨社区长者照护之家',
    address: {
      lat: '31.240929',
      lng: '121.407393',
    },
  },
  {
    name: '上海普陀区美源养老院',
    address: {
      lat: '31.2297',
      lng: '121.37522',
    },
  },
  {
    name: '上海中环逸仙敬老院',
    address: {
      lat: '31.272568',
      lng: '121.397392',
    },
  },
  {
    name: '武汉（南湖）',
    address: {
      lat: '30.507373',
      lng: '114.313595',
    },
  },
  {
    name: '爱照护（金杨）',
    address: {
      lat: '31.245875',
      lng: '121.577022',
    },
  },
  {
    name: '爱照护（江浦）',
    address: {
      lat: '31.26735',
      lng: '121.513598',
    },
  },
  {
    name: '爱照护（石泉）',
    address: {
      lat: '31.244022',
      lng: '121.421365',
    },
  },
  {
    name: '上海徐汇区源梦颐养院',
    address: {
      lat: '31.114144',
      lng: '121.455541',
    },
  },
  {
    name: '上海康健社区寿昌坊长者照护之家',
    address: {
      lat: '31.15015',
      lng: '121.420875',
    },
  },
  {
    name: '徐汇区精神卫生中心',
    address: {
      lat: '31.173163',
      lng: '121.446913',
    },
  },
  {
    name: '长宁区精神卫生中心',
    address: {
      lat: '31.2134',
      lng: '121.35471',
    },
  },
  {
    name: '上海市同济大学附属同济医院',
    address: {
      lat: '31.267023',
      lng: '121.430778',
    },
  },
  {
    name: '上海奉贤区南桥镇关港养老院',
    address: {
      lat: '30.992286',
      lng: '121.470635',
    },
  },
  {
    name: '上海凉城复馨敬老院',
    address: {
      lat: '31.30524',
      lng: '121.469947',
    },
  },
  {
    name: '长寿西沙长照',
    address: {
      lat: '31.219517',
      lng: '121.470674',
    },
  },
  {
    name: '太原（解二）',
    address: {
      lat: '37.849004',
      lng: '112.556498',
    },
  },
  {
    name: '兰州（科苑）',
    address: {
      lat: '36.052015',
      lng: '103.867553',
    },
  },
  {
    name: '武汉（常青）',
    address: {
      lat: '30.632273',
      lng: '114.238354',
    },
  },
  {
    name: '成都（万晟）',
    address: {
      lat: '30.659931',
      lng: '104.112795',
    },
  },
  {
    name: '济南大明湖社区爱照护长者照护之家',
    address: {
      lat: '36.671819',
      lng: '117.033064',
    },
  },
  {
    name: '济南（制锦市）',
    address: {
      lat: '36.669324',
      lng: '117.011343',
    },
  },
  {
    name: '上海普陀区忆桃园长者照护之家',
    address: {
      lat: '31.260297',
      lng: '121.405181',
    },
  },
  {
    name: '爱照护（临汾）',
    address: {
      lat: '31.311981',
      lng: '121.4589',
    },
  },
  {
    name: '爱照护（大宁）',
    address: {
      lat: '31.30238',
      lng: '121.462471',
    },
  },
  {
    name: '爱照护（欧阳）',
    address: {
      lat: '31.272914',
      lng: '121.497685',
    },
  },
  {
    name: '爱照护（甘泉R）',
    address: {
      lat: '31.260647',
      lng: '121.426632',
    },
  },
  {
    name: '爱照护（淞南）',
    address: {
      lat: '31.33052',
      lng: '121.46476',
    },
  },
  {
    name: '爱照护（枫林）',
    address: {
      lat: '31.194493',
      lng: '121.457801',
    },
  },
  {
    name: '爱照护（嘉兴）',
    address: {
      lat: '31.268392',
      lng: '121.504738',
    },
  },
  {
    name: '爱照护（龙华）',
    address: {
      lat: '31.168102',
      lng: '121.449573',
    },
  },
  {
    name: '爱照护（东安）',
    address: {
      lat: '31.187939',
      lng: '121.458229',
    },
  },
  {
    name: '爱照护（潍坊）',
    address: {
      lat: '31.218668',
      lng: '121.523911',
    },
  },
  {
    name: '爱照护（江湾）',
    address: {
      lat: '31.306888',
      lng: '121.47776',
    },
  },
  {
    name: '上海市第六人民医院记忆门诊',
    address: {
      lat: '31.178478',
      lng: '121.422378',
    },
  },
  {
    name: '爱照护（岳阳）',
    address: {
      lat: '31.016407',
      lng: '121.223932',
    },
  },
  {
    name: '呼和浩特如意开发区如意和大街分公司',
    address: {
      lat: '40.832527',
      lng: '111.77864',
    },
  },
  {
    name: '爱照护（真如）',
    address: {
      lat: '31.249744',
      lng: '121.391136',
    },
  },
  {
    name: '上海长征医院记忆门诊',
    address: {
      lat: '31.232211',
      lng: '121.467565',
    },
  },
  {
    name: '上海市第十人民医院',
    address: {
      lat: '31.272141',
      lng: '121.453407',
    },
  },
  {
    name: '上海交通大学医学院附属新华医院',
    address: {
      lat: '31.274082',
      lng: '121.518363',
    },
  },
  {
    name: '上海交大附属瑞金医院记忆门诊',
    address: {
      lat: '31.21175',
      lng: '121.467641',
    },
  },
  {
    name: '复旦大学附属华东医院记忆门诊',
    address: {
      lat: '31.21829',
      lng: '121.44154',
    },
  },
  {
    name: '复旦大学附属华山医院记忆门诊',
    address: {
      lat: '31.216063',
      lng: '121.442959',
    },
  },
  {
    name: '上海银康老年公寓',
    address: {
      lat: '31.309685',
      lng: '121.471658',
    },
  },
  {
    name: '上海浦东新区青墩养老院',
    address: {
      lat: '31.222099',
      lng: '121.720184',
    },
  },
  {
    name: '春天家园老年公寓',
    address: {
      lat: '31.143486',
      lng: '121.50991',
    },
  },
  {
    name: '上海徐汇区徐家汇街道龙吴路养老院',
    address: {
      lat: '31.170728',
      lng: '121.44405',
    },
  },
  {
    name: '上海徐汇区徐家汇街道南丹长者照护之家',
    address: {
      lat: '31.191978',
      lng: '121.430826',
    },
  },
  {
    name: '上海普陀区石岚敬老院',
    address: {
      lat: '31.249284',
      lng: '121.426746',
    },
  },
  {
    name: '静安区精神卫生中心',
    address: {
      lat: '31.231353',
      lng: '121.441232',
    },
  },
  {
    name: '上海金山区伯仁养护院',
    address: {
      lat: '30.894356',
      lng: '121.00482',
    },
  },
  {
    name: '上海爱照护武爱护理站',
    address: {
      lat: '31.27607',
      lng: '121.399713',
    },
  },
  {
    name: '上海市徐汇区久康养老院',
    address: {
      lat: '31.121624',
      lng: '121.453045',
    },
  },
  {
    name: '上海康乐福养老院',
    address: {
      lat: '31.236093',
      lng: '121.359345',
    },
  },
]
